import React from 'react'
import {
    SET_DAYS_LIST,
    SET_CURRENT_DAY,
    SET_INTERVENTIONS,
    SET_ORDER_BY,
    SET_CURRENT_INTERVENTION,
    SET_SELECTED_DISPLAY_MODE,
    SET_SELECTED_DAY,
    SET_INTERVENTIONS_BLOC_TYPES,
    SET_BLOCS,
    IS_LOADING,
    SET_PREVIEW,
    SET_CURRENT_TIME_SLOT,
    SET_IMPUTATION_REDIRECTION,
    TIME_SLOT_BLOC_TYPE_CODE,
    TIME_SLOT_END_TIME,
    TIME_SLOT_END_DAY,
    TIME_SLOT_START_DAY,
    TIME_SLOT_START_TIME,
    SET_DISPLAY_ENDED_INTERVENTIONS,
    SET_BLOCS_HEIGHT,
    SET_FILTERED_AND_SORTED_INTERVENTIONS,
    SET_UPDATING_BLOC,
    SET_EXPANDED_BLOC,
    SEARCH_BY_INTERVENTION_NUMBER,
    PAUSED_INTERVENTIONS_TYPE_ID,
} from './interventionConstants';
import { throwErrorMessage, throwWarning, removeAllNotifications } from '../../lib/error_helper';
import { fetchWithTimeout } from '../../lib/fetch_wrapper';
import { guid, clone } from '../../utils';
import moment from 'moment';
import db from '../../db';
import { submitInterventionInDb, synchronizeIntervention, removeIntervention } from './interventionEditionActions';
import { evaluateDynamicPropertyOfField, mergeFieldValueAndFieldType, checkDynamicPropertyOfField, evaluateDynamicPropertyOfBloc } from '../../lib/evaluateStringAsCodeHelper';
import { arraysAreSame } from '../../lib/array_helper'
import { sort, filter } from '../../redux/intervention/interventionSortAndFilter';
import { adaptInterventionForMyOpen, castInterventionFromDb, adaptInterventionForOpenERP } from '../../redux/intervention/interventionsCast'
import { BusinessInterventionError } from './BusinessInterventionError';
import { disabledIntervention } from './interventionStatusActions';
import { ALL_SELECT_OPTION } from '../../constants';

export function setImputationRedirectionModalOpennedAction(value) {
    return {
        imputationRedirectionModalOpenned: value,
        type: SET_IMPUTATION_REDIRECTION,
    }
}

export function interventionsIsLoading(value) {
    return {
        type: IS_LOADING,
        info: 'interventions',
        isLoading: value
    };
}

export function setBlocsHeightAction(blocsHeight) {
    return {
        type: SET_BLOCS_HEIGHT,
        blocsHeight,
    }
}

export function setExpandedBlocAction(expandedBloc) {
    return {
        type: SET_EXPANDED_BLOC,
        expandedBloc,
    }
}

export function setDaysListAction(daysList) {
    return {
        type: SET_DAYS_LIST,
        daysList: daysList,
    };
}

export function setCurrentDayAction(currentDay) {
    return {
        type: SET_CURRENT_DAY,
        currentDay: currentDay,
    };
}

export function setInterventionsAction(interventions) {
    return {
        type: SET_INTERVENTIONS,
        interventions: interventions,
    };
}

export function setFilteredAndSortedInterventionsAction(interventions) {
    return {
        type: SET_FILTERED_AND_SORTED_INTERVENTIONS,
        interventions,
    }
}

export function setPreviewAction(preview) {
    return {
        type: SET_PREVIEW,
        preview,
    };
}

export function setOrderByAction(orderBy) {
    return {
        type: SET_ORDER_BY,
        orderBy: orderBy,
    };
}

export function setDisplayEndedInterventionsAction(displayEndedInterventions) {
    return {
        type: SET_DISPLAY_ENDED_INTERVENTIONS,
        displayEndedInterventions,
    }
}

export function setSelectedDayAction(selectedDay) {
    return {
        type: SET_SELECTED_DAY,
        selectedDay,
    }
}

export function setCurrentInterventionAction(currentIntervention) {
    return {
        type: SET_CURRENT_INTERVENTION,
        currentIntervention: currentIntervention,
    };
}

export function setCurrentTimeSlotAction(currentTimeSlot) {
    return {
        type: SET_CURRENT_TIME_SLOT,
        currentTimeSlot,
    }
}

export function setBlocsAction(blocs) {
    return {
        type: SET_BLOCS,
        blocs: blocs,
    }
}

export function setSelectedDisplayModeAction(currentModeId) {
    return {
        type: SET_SELECTED_DISPLAY_MODE,
        currentModeId: currentModeId,
    }
}

export function setBlocTypesAction(blocTypes) {
    return {
        type: SET_INTERVENTIONS_BLOC_TYPES,
        blocTypes: blocTypes,
    }
}

export function searchByInterventionNumberAction(input) {
    return {
        type: SEARCH_BY_INTERVENTION_NUMBER,
        searchInput: input,
    }
}

export function setUpdatingBlocAction(updatingBloc) {
    return {
        type: SET_UPDATING_BLOC,
        updatingBloc,
    }
}

export function setPreview(preview) {
    return (dispatch) => {
        dispatch(setPreviewAction(preview));
    }
}

export function setBlocs(blocs) {
    return (dispatch) => {
        dispatch(setBlocsAction(blocs));
    }
}

export function setImputationRedirectionModalOpenned(value) {
    return (dispatch) => {
        dispatch(setImputationRedirectionModalOpennedAction(value));
    }
}

export function setUpdatingBloc(value) {
    return (dispatch) => {
        dispatch(setUpdatingBlocAction(value))
    }
}

export function setExpandedBloc(expandedBloc) {
    return (dispatch) => {
        dispatch(setExpandedBlocAction(expandedBloc))
    }
}

export function loadInterventionModel(discreet) {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            const headers = new Headers({ 'Content-Type': 'application/json' });
            fetchWithTimeout('/api/v1/interventions/report/block_types', {
                method: 'GET',
                headers: headers
            })
                .then((response) => {
                    if (!response.ok)
                        throw Error(response.statusText);

                    return response;
                })
                .then((response) => response.json())
                .then((blocTypes) => {
                    let sortedBlocTypes = blocTypes.sort((bt) => bt.sequence);
                    dispatch(setBlocTypesAction(sortedBlocTypes))

                    return resolve(sortedBlocTypes)
                }).catch((err) => {
                    console.error("Erreur : interventionActions - loadInterventionModel", err);

                    if (!discreet)
                        dispatch(throwErrorMessage({
                            errorObject: err,
                            title: "Erreur",
                            message: "Erreur lors de la récupération des types de bloc !",
                        }))

                    return reject(err);
                });
        })
    }
}

export function setDaysList(daysList) {
    return (dispatch) => {
        dispatch(setDaysListAction(daysList));
    }
}

export function setCurrentDay(currentDay) {
    return (dispatch) => {
        dispatch(setCurrentDayAction(currentDay));
    }
}

export function setCurrentIntervention(intervention, blocs) {
    return (dispatch) => {
        dispatch(setCurrentInterventionAction(intervention));

        if (blocs)
            dispatch(setBlocsAction(blocs));
        else
            dispatch(setBlocsAction(intervention.report_block_ids));
    }
}

export function loadIntervention(intervention) {
    return (dispatch) => {

        dispatch(setImputationRedirectionModalOpenned(false))
        dispatch(loadInterventionModel());
        //Intervention potentiellement incomplète (OT allégé de la liste des OT)
        //Cependant on ne peut pas se permettre d'attendre la fin de la requête pour charger l'OT
        //Sinon le composant Intervention redirige vers la liste d'OT
        dispatch(setCurrentIntervention(intervention));

        if (intervention.id) {
            getWorkOrderById(intervention.id).then((intervention) => {
                dispatch(setCurrentIntervention(intervention));
            })
        } else {
            getWorkOrderByMobileId(intervention.mobile_id).then((intervention) => {
                dispatch(setCurrentIntervention(intervention));
            })
        }
    }
}

export function setOrderBy(orderBy, interventionsFilters) {
    return (dispatch) => {
        dispatch(interventionsIsLoading(true));
        dispatch(setOrderByAction(orderBy));
        interventionsFilters.sortingModeId = orderBy;
        dispatch(setFilteredAndSortedInterventions(interventionsFilters))
    }
}

export function setDisplayEndedInterventions(displayEndedInterventions, interventionsFilters) {
    return (dispatch) => {
        dispatch(interventionsIsLoading(true));
        dispatch(setDisplayEndedInterventionsAction(displayEndedInterventions));
        interventionsFilters.displayEndedInterventions = displayEndedInterventions;
        dispatch(setFilteredAndSortedInterventions(interventionsFilters))
    }
}

export function searchByInterventionNumber(input, interventionsFilters) {
    return (dispatch) => {
        dispatch(interventionsIsLoading(true));
        dispatch(searchByInterventionNumberAction(input));
        interventionsFilters.searchInput = input;
        dispatch(setFilteredAndSortedInterventions(interventionsFilters))
    }
}

export function setSelectedDay(selectedDay, interventionsFilters) {
    return (dispatch) => {
        dispatch(interventionsIsLoading(true));
        dispatch(setSelectedDayAction(selectedDay));
        interventionsFilters.selectedDay = selectedDay;
        dispatch(setFilteredAndSortedInterventions(interventionsFilters))
    }
}

export function setSelectedDisplayMode(selectedDisplayModeId, interventionsFilters) {
    return (dispatch) => {
        dispatch(interventionsIsLoading(true));
        dispatch(setSelectedDisplayModeAction(selectedDisplayModeId))
        interventionsFilters.currentModeId = selectedDisplayModeId;
        dispatch(setFilteredAndSortedInterventions(interventionsFilters))
    }
}

export function generateBlocs(blocTypes, intervention, user, stateAccessor) {
    let blocs = [];

    blocTypes.filter((bt) => bt.published && bt.create_by_default !== "no").forEach((bt) => {

        if (bt.create_by_default !== ALL_SELECT_OPTION && (bt.create_by_default === "ot_manager"
            && intervention.tec_manager_id.id !== user.emp_id))
            return;

        blocs.push(generateDefaultBloc(bt, intervention.id, user, stateAccessor));
    })

    return blocs;
}

export function generateDefaultBloc(blocType, interventionId, user, stateAccessor, blocId = guid()) {
    let field_ids = [];

    blocType.field_ids.forEach((f) => {
        field_ids.push(generateDefaultField(f, blocId, stateAccessor));
    })

    return {
        type_id: blocType.id,
        mobile_id: blocId,
        field_ids,
        mobile_creation_date: moment().format('YYYY-MM-DD HH:mm:ss'),
        mobile_write_id: user.id,
        mobile_write_date: moment().format('YYYY-MM-DD HH:mm:ss'),
        validated: false,
        work_order_id: interventionId,
    }
}

export function generateDefaultField(fieldType, blocId, stateAccessor) {
    let fieldValue = {
        type_id: fieldType.id,
        block_id: blocId,
    };

    fieldValue = fillDefaultValues(fieldValue, fieldType, stateAccessor);

    return fieldValue;
}

function fillDefaultValues(fieldValue, fieldType, stateAccessor) {
    let field = Object.assign(clone(fieldValue), clone(fieldType));

    let defaultValue;
    if (fieldType.default_value_formula)
        defaultValue = evaluateDynamicPropertyOfField([field], fieldType, "default_value_formula", undefined, stateAccessor)

    switch (fieldType.value_type) {
        case "text":
            if (!defaultValue)
                defaultValue = fieldType.default_value_text;

            fieldValue.value_text = defaultValue;
            break;
        case "float":
            if (!defaultValue)
                defaultValue = fieldType.default_value_float;

            fieldValue.value_float = defaultValue;
            break;
        case "integer":
            if (!defaultValue)
                defaultValue = fieldType.default_value_int;

            fieldValue.value_int = defaultValue;
            break;
        case "boolean":
            if (!defaultValue)
                defaultValue = fieldType.default_value_bool;

            fieldValue.value_bool = defaultValue;
            break;
        case "date":
            if (!defaultValue)
                defaultValue = fieldType.default_value_date;

            fieldValue.value_date = defaultValue;
            break;
        case "choice":
            if (!defaultValue)
                defaultValue = fieldType.default_value_choice_id.id ? fieldType.default_value_choice_id.id : "";

            fieldValue.value_choice_id = defaultValue;
            break;
        case "choices":
            if (!defaultValue)
                defaultValue = [fieldType.default_value_choice_id ? fieldType.default_value_choice_id.id : ""];

            fieldValue.value_choice_ids = defaultValue;
            break;
        case "fields":
            if (!defaultValue)
                defaultValue = [];

            fieldValue.value_field_ids = defaultValue;
            break;
        case "picture":
        case "signature":
            if (!defaultValue)
                defaultValue = null;

            fieldValue.value_image = defaultValue;
            break;
        case "quantity_value":
            if (!defaultValue)
                defaultValue = fieldType.default_value_text;

            fieldValue.value_text = defaultValue;
            fieldValue.value_float = fieldType.default_value_float;
            break;
        default:
            break;
    }

    return fieldValue;
}

export function atLeastOneValueChanged(fieldValue) {
    let floatChanged = fieldValue.value_float !== undefined && fieldValue.value_float !== 0;
    let intChanged = fieldValue.value_int !== undefined && fieldValue.value_int !== 0;
    let textChanged = fieldValue.value_text !== undefined && fieldValue.value_text !== "";
    let imageChanged = fieldValue.value_image ? true : false;
    let dateChanged = fieldValue.value_date ? true : false;
    let choicesChanged = fieldValue.value_choice_ids && fieldValue.value_choice_ids.length > 0;
    let choiceChanged = fieldValue.value_choice_id ? true : false;
    let arrayChanged = arrayHasBeenChangedAndAllLinesAreFilled(fieldValue);


    let valueChanged = floatChanged || intChanged || textChanged ||
        imageChanged || dateChanged || choicesChanged || choiceChanged || arrayChanged

    return valueChanged;
}

function arrayHasBeenChangedAndAllLinesAreFilled(fieldValue) {

    if (!fieldValue.value_field_ids || fieldValue.value_field_ids.length <= 0)
        return false;

    let allLinesAreFilled = true;

    fieldValue.value_field_ids.forEach(child => {
        let childHasBeenChanged = atLeastOneValueChanged(child)

        if (!childHasBeenChanged)
            allLinesAreFilled = false
    });

    return allLinesAreFilled
}

export function fieldValueChange(blocId, fieldId, fieldValue, blocs, userId, intervention) {
    return (dispatch) => {
        let copyOfBlocs = blocs.concat();
        let bloc = copyOfBlocs.find((b) => b.mobile_id === blocId);

        if (!bloc) {
            console.error("Le bloc est introuvable");
            return;
        }

        bloc.mobile_write_date = moment().format('YYYY-MM-DD HH:mm:ss');
        bloc.mobile_write_id = userId;

        let fieldIndex = bloc.field_ids.findIndex((f) => f.type_id === fieldId);

        if (fieldIndex === undefined || fieldIndex === null) {
            console.error("Le champ est introuvable");
            return;
        }

        fieldValue = Object.assign(bloc.field_ids[fieldIndex], fieldValue)
        bloc.field_ids.splice(fieldIndex, 1, fieldValue)
        intervention.locallyModified = true;
        dispatch(setBlocsAction(copyOfBlocs));
        submitInterventionInDb(intervention, copyOfBlocs);
    }
}

export function addOrRemoveBloc(blocTypeId, blocId, addBlocAction, blocs, blocTypes, intervention, user, stateAccessor) {
    return (dispatch) => {

        if (intervention.internalState !== "started" || intervention.state !== "performed") {
            dispatch(throwErrorMessage({
                title: "Erreur",
                message: "Impossible d'ajouter ou supprimer un bloc si l'intervention n'est pas démarrée"
            }))
            return;
        }

        if (addBlocAction) {
            let blocType = blocTypes.find((bt) => bt.id === blocTypeId);

            if (!blocType) {
                console.error("Impossible de trouver ce type de bloc");
                return;
            }

            if (!blocType.published) {
                console.error("Impossible d'ajouter ce type de bloc car il n'est pas publié");
                return;
            }

            let bloc = generateDefaultBloc(blocType, intervention.id, user, stateAccessor, blocId);
            bloc.mobile_write_date = moment().format('YYYY-MM-DD HH:mm:ss');
            bloc.mobile_write_id = user.id;

            blocs.push(bloc);
        } else {
            let blocToDelete = blocs.find((b) => b.mobile_id === blocId);
            blocToDelete.mobile_write_date = moment().format('YYYY-MM-DD HH:mm:ss');
            blocToDelete.mobile_write_id = user.id;
            blocToDelete.deleted = true;
        }

        intervention.locallyModified = true;

        dispatch(setBlocsAction(blocs));
        submitInterventionInDb(intervention, blocs);
    }
}

export function interventionsAreDifferents(interventionA, interventionB) {

    try {
        if (interventionA !== interventionB)
            throw new Error("Les interventions sont différentes");

        if (interventionA.report_block_ids.length !== interventionB.report_block_ids.length)
            throw new Error("Les interventions sont différentes");

        if (blocsModifiedDatesAreDifferents(interventionA.report_block_ids, interventionB.report_block_ids))
            throw new Error("Les interventions sont différentes");
    } catch (error) {
        return true
    }

    return false;
}

export function blocsModifiedDatesAreDifferents(blocsA, blocsB) {

    try {
        if (blocsA.length !== blocsB.length)
            throw new Error("Les blocs sont différents");

        blocsA.forEach((blocA) => {
            blocsB.forEach((blocB) => {
                if (blocA.mobile_write_date !== blocB.mobile_write_date)
                    throw new Error("Les blocs sont différents");
            })
        });
    } catch (error) {
        return true
    }

    return false;
}

export function blocsAreDifferents(blocsA, blocsB) {
    try {
        if (blocsA.length !== blocsB.length)
            throw new Error("Les blocs sont différents");

        blocsA.forEach((blocA) => {
            blocsB.forEach((blocB) => {
                if (blocA.mobile_id !== blocB.mobile_id)
                    return;

                if (blocHasChanged(blocA, blocB))
                    return true;
            })
        });
    } catch (error) {
        return true
    }

    return false;
}

export function blocHasChanged(blocA, blocB) {

    if (blocA.validated !== blocB.validated)
        throw new Error("Le bloc a été validé ou dévalidé");

    if (blocA.deleted !== blocB.deleted)
        throw new Error("Le bloc a été supprimé");

    if (blocA !== blocB)
        throw new Error("Les blocs sont différents");

    if (fieldsAreDifferents(blocA.field_ids, blocB.field_ids))
        throw new Error("Les blocs sont différents");

    return false;
}

export function fieldsAreDifferents(fieldsA, fieldsB) {
    let fieldsDifferents = false;

    fieldsA.forEach((fieldA) => {
        fieldsB.forEach((fieldB) => {
            if (fieldA.type_id === fieldB.type_id && fieldA !== fieldB)
                throw new Error("Les champs sont différents");

            if (!arraysAreSame(fieldA.value_choice_ids, fieldB.value_choice_ids))
                throw new Error("Les champs sont différents");

            if (!arraysAreSame(fieldA.value_field_ids, fieldB.value_field_ids))
                throw new Error("Les champs sont différents");
        })
    });

    return fieldsDifferents;
}

export function filtersOnlyPausedInterventionsByCustomer(interventionsFilters, customerId, excludeCurrentInterventionId) {
    return (dispatch) => {

        dispatch(setSelectedDisplayMode(PAUSED_INTERVENTIONS_TYPE_ID, interventionsFilters))
        interventionsFilters.currentModeId = PAUSED_INTERVENTIONS_TYPE_ID;
        interventionsFilters.displayEndedInterventions = false;
        interventionsFilters.searchInput = null;
        interventionsFilters.customerId = customerId
        dispatch(setFilteredAndSortedInterventions(interventionsFilters, null, null, excludeCurrentInterventionId))
    }
}

export function setFilteredAndSortedInterventions(interventionsFilters, interventions, discreet, excludeCurrentInterventionId) {
    return (dispatch) => {
        if (!discreet)
            dispatch(interventionsIsLoading(true));

        if (!interventions) {
            db.Intervention.toArray((interventions) => {
                let lightInterventions = [];

                interventions.forEach(intervention => {
                    let clonedIntervention = clone(intervention);
                    delete clonedIntervention['report_block_ids']
                    clonedIntervention.report_block_ids = []
                    lightInterventions.push(clonedIntervention)
                })

                return lightInterventions;
            }).then((interventions) => {
                let transformedInterventions = [];

                interventions.forEach((i) => {
                    transformedInterventions.push(castInterventionFromDb(i));
                })

                dispatch(applyFiltersAndSortInterventions(interventionsFilters, transformedInterventions, excludeCurrentInterventionId))
            }).catch((err) => {
                console.error("Erreur : interventionActions - setFilteredAndSortedInterventions", err);

                if (!discreet) {
                    dispatch(throwErrorMessage({
                        errorObject: err,
                        title: "Erreur",
                        message: "Erreur lors de la récupération des interventions !",
                    }))

                    dispatch(interventionsIsLoading(false));
                }
            })
        } else {
            dispatch(applyFiltersAndSortInterventions(interventionsFilters, interventions, excludeCurrentInterventionId));
        }
    }
}

function applyFiltersAndSortInterventions(interventionsFilters, interventions, excludeCurrentInterventionId) {
    return (dispatch) => {
        let sortingMode = interventionsFilters.sortingModes[interventionsFilters.sortingModeId]
        let displayMode = interventionsFilters.modeList[interventionsFilters.currentModeId];
        let filteredInterventions = filter(interventions, displayMode, interventionsFilters.selectedDay, interventionsFilters.displayEndedInterventions, interventionsFilters.searchInput, interventionsFilters.customerId, excludeCurrentInterventionId);
        let sortedAndFilteredInterventions = sort(filteredInterventions, sortingMode);
        dispatch(setFilteredAndSortedInterventionsAction(sortedAndFilteredInterventions));
        dispatch(interventionsIsLoading(false));
    }
}

export function getStartedWorkOrder() {
    return new Promise((resolve, reject) => {
        return db.Intervention.toArray().then((interventions) => {
            let intervention;

            interventions.forEach((i) => {
                if (i.state === "performed" && i.internalState === "started") {
                    i.date_planned_start = moment.utc(i.date_planned_start);
                    intervention = i;
                    return;
                }
            })

            return resolve(intervention);
        }).catch((err) => {
            return reject(err);
        });
    })
}

export function synchronizeWorkOrders(user, blocTypes, stateAccessor, history, onSynchronized, discreet) {
    return (dispatch) => {
        const headers = new Headers({ 'Content-Type': 'application/json' });

        if (!discreet)
            dispatch(interventionsIsLoading(true));

        db.Intervention.toArray().then((interventions) => {

            let writeDateOfWorkOrders = {}

            interventions.forEach((i) => {
                if (!i.id) {
                    writeDateOfWorkOrders[i.mobile_id] = adaptInterventionForOpenERP(i);
                } else {
                    writeDateOfWorkOrders[i.id] = i.write_date;
                }
            })

            fetchWithTimeout('/api/v3/interventions/get_my_work_orders/', {
                method: 'POST',
                headers: headers,
                timeout: 60000,
                body: JSON.stringify({
                    workOrders: writeDateOfWorkOrders,
                    userId: user.id,
                    empId: user.emp_id,
                }),
            }).then((response) => {
                if (!response.ok)
                    throw Error(response.statusText);

                return response;
            })
                .then((response) => response.json())
                .then((serverInterventions) => {
                    db.Intervention.toArray().then((dbInterventions) => {
                        let transformedInterventions = clone(dbInterventions);

                        transformedInterventions.forEach((i) => {
                            i.date_planned_start = moment.utc(i.date_planned_start);
                        })

                        let dbInterventionsAlwaysInOpenErp = []

                        serverInterventions.forEach((si) => {
                            let transformedIntervention = si;
                            if (!si.no_update)
                                transformedIntervention = adaptInterventionForMyOpen(si);

                            let dbIntervention = dbInterventions.find((dbi) => dbi.id === si.id || dbi.mobile_id === si.mobile_id);

                            if (!dbIntervention) {
                                submitInterventionInDb(transformedIntervention, transformedIntervention.report_block_ids);
                                transformedInterventions.push(transformedIntervention);
                            } else {
                                dbInterventionsAlwaysInOpenErp.push(dbIntervention);

                                if (dbIntervention.locallyModified)
                                    dispatch(synchronizeIntervention(dbIntervention, dbIntervention.report_block_ids, user, blocTypes, history, stateAccessor, false, false, false))
                                else {
                                    if (!si.no_update) {
                                        transformedIntervention.internalState = dbIntervention.internalState;
                                        submitInterventionInDb(transformedIntervention, transformedIntervention.report_block_ids);
                                        let indexOfUpdatedIntervention = transformedInterventions.findIndex((i) => i.id === si.id)
                                        transformedInterventions.splice(indexOfUpdatedIntervention, 1, transformedIntervention)
                                    }
                                }
                            }
                        })

                        dbInterventions.forEach(dbI => {
                            if (!dbInterventionsAlwaysInOpenErp.includes(dbI))
                                dispatch(removeIntervention(dbI, history))
                        })

                        dispatch(setInterventionsAction(transformedInterventions));

                        if (onSynchronized && typeof (onSynchronized) === "function")
                            onSynchronized(transformedInterventions);

                        if (!discreet)
                            dispatch(interventionsIsLoading(false));
                    }).catch((err) => {
                        console.error("Erreur : interventionActions - synchronizeWorkOrders", err);

                        if (!discreet) {
                            dispatch(throwErrorMessage({
                                errorObject: err,
                                title: "Erreur",
                                message: "Erreur lors de la récupération des interventions !",
                            }))

                            dispatch(interventionsIsLoading(false));
                        }
                    });
                }).catch((err) => {
                    console.error("Erreur : interventionActions - synchronizeWorkOrders", err);

                    if (!discreet) {
                        dispatch(throwErrorMessage({
                            errorObject: err,
                            title: "Erreur",
                            message: "Erreur lors de la récupération des interventions !",
                        }))

                        dispatch(interventionsIsLoading(false));
                    }
                });
        })
    }
}

export function getFieldVisibility(blocs, blocTypes, blocId, model, stateAccessor) {
    let fields = mergeFieldValueAndFieldType(blocs, blocTypes, blocId, null, model)
    let defaultValue = true;

    let visibilityResult = checkDynamicPropertyOfField(fields, model, "visibility_condition", defaultValue, stateAccessor);

    if (typeof visibilityResult === "boolean")
        return visibilityResult;
    else if (typeof visibilityResult === "string" && visibilityResult)
        return defaultValue;


    return defaultValue;
}

export function getFieldMandatory(blocs, blocTypes, blocId, model, stateAccessor) {
    let fields = mergeFieldValueAndFieldType(blocs, blocTypes, blocId, null, model)
    let defaultValue = false;

    if (!model.mandatory)
        return false;

    if (!model.mandatory_condition)
        return true;

    let mandatoryResult = checkDynamicPropertyOfField(fields, model, "mandatory_condition", defaultValue, stateAccessor);

    if (typeof mandatoryResult === "boolean")
        return mandatoryResult;
    else if (typeof mandatoryResult === "string" && mandatoryResult)
        return defaultValue;

    return defaultValue;
}

export function validateBlocs(blocs, intervention, blocTypes, user, stateAccessor) {
    return (dispatch) => {
        return new Promise((resolve, reject) => {

            let promises = [];
            let newBlocs = []
            let empIsManager = intervention.tec_manager_id.id === user.emp_id

            blocs.forEach((b) => {
                if (b.deleted) {
                    newBlocs.push(b);
                    return;
                }

                let blocType = blocTypes.find((bt) => bt.id === b.type_id);

                if (!b.validated) {
                    if (empIsManager || blocType.needs_validation_for_assistant) {
                        promises.push(dispatch(validateBloc(b, intervention, blocs, blocTypes, blocType, stateAccessor, user)).then((bloc) => {
                            newBlocs.push(bloc);
                        }))
                    } else
                        newBlocs.push(b);
                } else
                    newBlocs.push(b);
            })

            Promise.all(promises).then(() => {
                return resolve(newBlocs);
            }).catch((err) => {
                dispatch(throwErrorMessage({
                    title: "Une erreur s'est produite lors de la validation des blocs",
                }))

                return reject(err);
            })
        })
    }
}

export function validateBloc(bloc, intervention, blocs, blocTypes, blocType, stateAccessor, user, previewMode = true) {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            if (blocType.code === TIME_SLOT_BLOC_TYPE_CODE) {
                bloc.validated = !bloc.validated;
                bloc.mobile_write_date = moment().format('YYYY-MM-DD HH:mm:ss');
                return resolve(bloc);
            }

            let action

            if (previewMode)
                action = {
                    label: 'Aller sur le bloc',
                    callback: () => {
                        dispatch(setUpdatingBloc(bloc))
                        dispatch(removeAllNotifications());
                    }
                }

            if (!userCanValidateBloc(user, intervention, blocType))
                return reject(bloc);

            if (!bloc.validated) {

                let errors = checkCoherence(blocs, blocTypes, bloc.mobile_id, blocType, stateAccessor)
                errors = errors.concat(mandatoryFieldsFilled(blocs, bloc.mobile_id, blocType, blocTypes, stateAccessor, previewMode))
                let criticalErrors = errors.filter((e) => !e.isWarning)
                let warningErrors = errors.filter((e) => e.isWarning)

                if (warningErrors.length > 0)
                    dispatch(throwWarning({
                        title: "Attention",
                        message: (<ul>{warningErrors.map((e, i) => (<li key={i}>{e.message}</li>))}</ul>),
                        action
                    }))

                if (criticalErrors.length > 0) {
                    dispatch(throwErrorMessage({
                        title: "Erreur",
                        message: (<ul>{criticalErrors.map((e, i) => (<li key={i}>{e.message}</li>))}</ul>),
                        action
                    }))

                    return reject(bloc);
                }

            }

            bloc.validated = !bloc.validated;
            bloc.mobile_write_date = moment().format('YYYY-MM-DD HH:mm:ss');

            return resolve(bloc);
        })
    }
}

export function mandatoryFieldsFilled(blocs, currentBlocId, blocType, blocTypes, stateAccessor) {
    let errors = [];

    let blocValues = blocs.find((bv) => bv.mobile_id === currentBlocId)

    if (blocValues === undefined) {
        console.error("Valeurs introuvables");
        return errors;
    }

    blocValues.field_ids.forEach((f) => {
        let fieldType = blocType.field_ids.find((bv) => bv.id === f.type_id);
        let fieldVisible = getFieldVisibility(blocs, blocTypes, currentBlocId, fieldType, stateAccessor)
        let fieldMandatory = getFieldMandatory(blocs, blocTypes, currentBlocId, fieldType, stateAccessor)

        if (!fieldType) {
            console.error("Le type de champs est introuvable. Impossible de vérifier que les champs obligatoires sont renseignés");
            return errors;
        }

        let blocSubTitle = "";
        let fields = mergeFieldValueAndFieldType(blocs, blocTypes, currentBlocId, blocType)
        blocSubTitle = evaluateDynamicPropertyOfBloc(fields, blocType, "display_title_formula", "", stateAccessor)
        blocSubTitle = blocSubTitle ? " - " + blocSubTitle : blocSubTitle;

        if (fieldVisible && fieldMandatory && !atLeastOneValueChanged(f)) {
            errors.push(new BusinessInterventionError("Le champ [" + fieldType.name + "] du bloc [" + blocType.name + blocSubTitle + "] n'a pas été renseigné alors qu'il est obligatoire"))
        }
    });

    return errors;
}

export function checkCoherence(blocs, blocTypes, currentBlocId, blocType, stateAccessor) {
    let fields = mergeFieldValueAndFieldType(blocs, blocTypes, currentBlocId, blocType)
    let errors = []
    let defaultValue = true;

    fields.forEach(f => {
        let coherenceResult = checkDynamicPropertyOfField(fields, f, "coherence", defaultValue, stateAccessor);
        let coherenceWarningResult = checkDynamicPropertyOfField(fields, f, "coherence_warning", defaultValue, stateAccessor);
        errors = errors.concat(interpretCoherenceResult(coherenceResult, f))
        errors = errors.concat(interpretCoherenceResult(coherenceWarningResult, f, true));
    })

    return errors;
}

export function interpretCoherenceResult(coherenceResult, field, warning = false) {
    let errors = []

    if (typeof coherenceResult === "boolean") {
        if (!coherenceResult) {
            let message = "Erreur lors du contrôle de cohérence du champ " + field.name;


            if (!warning) {
                if (field.error_message) {
                    message = field.error_message;
                }

                errors.push(new BusinessInterventionError(message))
            } else {
                if (field.warning_message) {
                    message = field.warning_message;
                }

                errors.push(new BusinessInterventionError(message, true))
            }
        }
    } else if (typeof coherenceResult === "string" && coherenceResult) {
        if (!warning) {
            errors.push(new BusinessInterventionError(coherenceResult))
        } else {
            errors.push(new BusinessInterventionError(coherenceResult, true))
        }
    }

    return errors;
}

//Return nb of hours spent on a workorder (all tech)
export function generateTotalTimeSpentOnWorkOrder(workOrder, blocTypes) {
    let timeSlotBlocType = blocTypes.find(bt => bt.code === TIME_SLOT_BLOC_TYPE_CODE);
    let totalTimeSpent = 0;

    if (!timeSlotBlocType)
        return totalTimeSpent;

    workOrder.report_block_ids.filter(b => b.type_id === timeSlotBlocType.id).forEach(b => {

        let timeSlotFieldTypeStartDateId = timeSlotBlocType.field_ids.find(f => f.code === TIME_SLOT_START_DAY);
        let timeSlotFieldTypeEndDateId = timeSlotBlocType.field_ids.find(f => f.code === TIME_SLOT_END_DAY);
        let timeSlotFieldTypeStartTimeId = timeSlotBlocType.field_ids.find(f => f.code === TIME_SLOT_START_TIME);
        let timeSlotFieldTypeEndTimeId = timeSlotBlocType.field_ids.find(f => f.code === TIME_SLOT_END_TIME);

        let timeSlotStartDateFieldValue = b.field_ids.find(f => f.type_id === timeSlotFieldTypeStartDateId.id).value_date;
        let timeSlotEndDateFieldValue = b.field_ids.find(f => f.type_id === timeSlotFieldTypeEndDateId.id).value_date;
        let timeSlotStartTimeFieldValue = b.field_ids.find(f => f.type_id === timeSlotFieldTypeStartTimeId.id).value_float;
        let timeSlotEndTimeFieldValue = b.field_ids.find(f => f.type_id === timeSlotFieldTypeEndTimeId.id).value_float;


        let startHours = parseInt(timeSlotStartTimeFieldValue);
        let startMinutes = (timeSlotStartTimeFieldValue - startHours) * 60;
        let endHours = parseInt(timeSlotEndTimeFieldValue);
        let endMinutes = (timeSlotEndTimeFieldValue - endHours) * 60;
        let startDate = moment(timeSlotStartDateFieldValue).hours(startHours).minutes(startMinutes);
        let endDate = moment(timeSlotEndDateFieldValue).hours(endHours).minutes(endMinutes);

        if (!timeSlotEndDateFieldValue)
            endDate = moment();

        totalTimeSpent += endDate.diff(startDate, 'hours', true)
    })

    return totalTimeSpent;
}

export function getWorkOrderByCode(code) {
    return new Promise((resolve) => {
        db.Intervention.toArray().then((interventions) => {
            let intervention = interventions.find(i => i.name === code);
            return resolve(intervention);
        })
    })
}

export function getWorkOrderById(id) {
    return new Promise((resolve) => {
        db.Intervention.toArray().then((interventions) => {
            let intervention = interventions.find(i => i.id === id);
            return resolve(intervention);
        })
    })
}

export function getWorkOrderByMobileId(mobileId) {
    return new Promise((resolve) => {
        db.Intervention.toArray().then((interventions) => {
            let intervention = interventions.find(i => i.mobile_id === mobileId);
            return resolve(intervention);
        })
    })
}

export function setBlocsHeight(blocsHeight) {
    return (dispatch) => {
        dispatch(setBlocsHeightAction(blocsHeight));
    }
}

export function userCanUpdateBloc(activeUser, intervention, bloc, blocType) {
    return userCanValidateBloc(activeUser, intervention, blocType) && !bloc.validated
}

export function userCanValidateBloc(activeUser, intervention, blocType) {

    let isAssistant = activeUser.emp_id !== intervention.tec_manager_id.id

    //Si c'est le responsable qui créé les blocs de ce type alors il n'y a que lui qui peut les modifier
    let assistantCanUpdate = blocType.create_by_default !== "ot_manager"

    return blocType.code !== TIME_SLOT_BLOC_TYPE_CODE
        && !disabledIntervention(intervention.state, intervention.internalState)
        && (!isAssistant || (isAssistant && assistantCanUpdate))
}
